var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60339 11.3319V19.0401H18.4034V11.298",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3234 13.28H7.20337V17.44H12.3234V13.28Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9235 19.04V13.28H16.8035V19.04",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60339 7.83999V6.23999H18.4034V7.83999",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4034 7.83997H5.60345C5.60345 7.83997 5.28345 9.44477 5.28345 10.24C5.28345 11.0352 5.60825 11.68 6.40345 11.68C6.85849 11.68 7.25945 11.4646 7.52345 11.135C7.78745 11.4646 8.18841 11.68 8.64345 11.68C9.09849 11.68 9.49945 11.4646 9.76345 11.135C10.0274 11.4646 10.4284 11.68 10.8834 11.68C11.3385 11.68 11.7394 11.4646 12.0034 11.135C12.2674 11.4646 12.6684 11.68 13.1234 11.68C13.5785 11.68 13.9798 11.4646 14.2434 11.135C14.5071 11.4646 14.9084 11.68 15.3634 11.68C15.8185 11.68 16.2198 11.4646 16.4834 11.135C16.7471 11.4646 17.1484 11.68 17.6034 11.68C18.3986 11.68 18.7234 11.0352 18.7234 10.24C18.7234 9.44477 18.4034 7.83997 18.4034 7.83997Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.00342 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.4c08b53fb0bcde9e120c0ab28e2897a9.svg";
export { ForwardRef as ReactComponent };